import type { QuestionType } from '@repo/types/enums/questionType';

import QuizItemNumberLabel from '@/components/features/quiz/quiz-resolver/QuizItemNumberLabel';
import { Badge } from '@/components/ui/badge';
import { questionsLabel } from '@/lib/questions-labels';

interface QuestionItemHeaderProps {
  questionIndex: number;
  type: QuestionType;
}

export default function QuestionItemHeader(questionItemHeaderProps: QuestionItemHeaderProps) {
  const { questionIndex, type } = questionItemHeaderProps;

  const label: string = questionsLabel[type].label;
  const IconComponent = questionsLabel[type].icon;

  return (
    <div className="flex justify-between gap-4">
      <QuizItemNumberLabel>Pytanie {questionIndex + 1}</QuizItemNumberLabel>
      <Badge variant={'muted'} size={'sm'}>
        <IconComponent />
        {label}
      </Badge>
    </div>
  );
}
